<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_list">Шаблоны</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Создать открытку</li>
        </ol>
    </nav>
	<div id="gratters_construct_input" style="display:block">
		<div class="row mb-4">
			<div class="col-12">
				<div class="form-label">Введите текст поздравления</div>
				<textarea class="form-control" rows="7" v-model="text"></textarea>
			</div>
		</div>
		
		<div class="row mb-4">
			<div style="width:857px">
				<div class="form-label">Предпросмотр</div>
				<div class="mb-3">Открытка в этом блоке будет выглядеть так же, как в ленте новостей Битрикс24.<br />Если текст выходит за габариты картинок, используйте перенос строк.</div>
				<div style="background-color:#fff;text-align:center">	
					<img v-bind:src="header" />
					<textarea class="text-output" readonly rows="7" v-model="text" ></textarea>
					<img v-bind:src="footer"/>
				</div>	
			</div>
		</div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <button class="btn btn-lg btn-primary me-3" @click.prevent="create">
                <span>Создать</span>
            </button>
            <button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
                <span>Отменить</span>
            </button>
        </div>
	</div>
	<div id="gratters_construct_output" style="display:none">
		<div class="mb-4">
			<div class="col-12">	
				<label class="form-label">Полученный bbcode</label>
				<textarea readonly class="form-control" rows="7" v-model="result"></textarea>
			</div>	
		</div>
		
		<div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
			<button class="btn btn-lg btn-primary me-3" @click.prevent="cancel">К списку шаблонов</button>
		</div>
	</div>
	
	<Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "GrattersDetailComponent",
	components: { Alert },
	props: [
		'element_id',
		'route_detail',
        'route_list'
    ],
	data: () => {
        return {
            name: '',
            header: '',
            headerName: '',
            footer: '',
            footerName: '',
            text: '',
            result: '',
        };
    },
	methods: {
		...mapMutations('alerts', ['addAlert']),
		cancel: function () {
			document.location = '/organizational/gratters-constructor/';
		},
		create: function () {
			if(this.text.trim() == '') {
				this.addAlert({ type: 'error', title: 'Ошибка', text: 'Текст поздравления не может быть пустым' });
			} else {
				
				this.result += '[CENTER]';
				if(this.header !== '') {
					this.result += '[IMG]' + this.header + '[/IMG]';
				}
				this.result += '[P][I][SIZE=16pt]' + this.text + '[/SIZE][/I][/P]';
				if(this.footer !== '') {
					this.result += '[IMG]' + this.footer + '[/IMG]';
				}
				this.result += '[/CENTER]';
				document.getElementById('gratters_construct_input').style.display = 'none'; 
				document.getElementById('gratters_construct_output').style.display = 'block';
			}	
		},
	},
	mounted() {
		axios.post(this.route_detail, {id: this.element_id})
			.then(res => {
				this.name = res.data.data.name;
				this.header = res.data.data.header ? res.data.data.header : '';
				this.headerName = res.data.data.header_name ? res.data.data.header_name : '';
				this.footer = res.data.data.footer ? res.data.data.footer : '';
				this.footerName = res.data.data.footer_name ? res.data.data.footer_name : '';
			});
    },
}
</script>

<style scoped>
	.text-output {
		font-size: 16pt;
		display: block;
		width: -webkit-fill-available;
		border: none;
		resize: none;
		font-style: italic;
		text-align: center;
	}
</style>